import React, { FunctionComponent } from 'react';

// types
import { DefaultBrandingSet } from 'ducks/merchantDucks/branding/types';

// components
import BrandHeader from './PaywallElements/BrandHeader';
import Footer from './PaywallElements/Footer';
import { PaywallContainer, SectionContainer, FormContainer, StyledInput, ButtonHolder, Button } from './StyledElements';

interface Props {
  branding: DefaultBrandingSet;
}

const DataCaptureScreen: FunctionComponent<Props> = ({ branding }) => {
  const {
    paywall_secondary_color: paywallSecondaryColor,
    paywall_brand_logo: paywallBrandLogo,
    paywall_primary_color: paywallPrimaryColor,
    paywall_buttons_bg_color: paywallButtonsBgColor,
  } = branding;

  return (
    <PaywallContainer>
      <BrandHeader backgroundColor={paywallSecondaryColor} brandLogo={paywallBrandLogo} />
      <SectionContainer>
        <FormContainer>
          <StyledInput type="text" placeholder="Email" readOnly />
          <StyledInput type="text" placeholder="Fullname" readOnly />
          <StyledInput type="text" placeholder="Company" readOnly />
          <ButtonHolder>
            <Button buttonBgColor={paywallButtonsBgColor}>Watch</Button>
          </ButtonHolder>
        </FormContainer>
      </SectionContainer>
      <Footer backgroundColor={paywallPrimaryColor} />
    </PaywallContainer>
  );
};

export default DataCaptureScreen;
